<template>
  <div id="app">
    <router-view v-if="tokenExists"/>
    <div v-else-if="!tokenExists" >
      <ErrorScreen/>
    </div>
  </div>
</template>

<script>

import ErrorScreen from './components/ErrorScreen.vue'

export default {
  name: 'App',
  components: {
    ErrorScreen,
  },
  beforeCreate: function(){
    // if(process.env.NODE_ENV === 'development'){
    //   // eslint-disable-next-line
    //   console.log("running in dev mode")
    //   document.cookie = 'token=3'
    // }
  },
  computed: {
    tokenExists : () => {
      // eslint-disable-next-line
      const token = $cookies.get("token")
      return token !== null
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Varela+Round&display=swap');
#app {
  font-family: 'Varela Round', sans-serif;
}

</style>
